import { Button } from "@mui/joy";
import useOpenTask from "hooks/useOpenTask";
import { useRecoilState, useRecoilValue } from "recoil";
import { patientAtom } from "recoil/patientAtom";
import { userAtom } from "../../recoil/userAtom";

export default function OpenChatButton() {
  const openChat = useOpenTask({ taskKey: "chat" });
  const userState = useRecoilValue(userAtom);
  const [patientState, setPatientState] = useRecoilState(patientAtom);

  const isAdmin = userState?.role === "admin";

  return (
    <Button
      variant={"Solid"}
      onClick={() => {
        openChat();

        if (!isAdmin && patientState) {
          setPatientState({ ...patientState, unreadMessageCount: 0 });
        }
      }}
    >
      채팅 확인하기
    </Button>
  );
}
